import React from 'react'
import { Trans, withI18nContext } from '@mc/i18n'
import { useMCProCertsCatalogValue } from '../../hooks/useMCProCertsCatalogValue'
import { useMCProExperiment } from '../../hooks/useMCProExperiment'
import { MC_PRO_TIER_I18N_NAMESPACE, i18nInstance } from '../../i18n'

const t = i18nInstance.getFixedT(null, MC_PRO_TIER_I18N_NAMESPACE)

const BENEFITS = ['everyCourse', 'newLaunches', 'relevant', 'prove'] as const

const BenefitsList = () => (
  <ul className='list-styled mc-mx-4 mc-px-4'>
    {BENEFITS.map((key) => (
      <li key={key}>{t(`faq.certificates.benefits.${key}`)}</li>
    ))}
  </ul>
)

const PlusCredit = () => (
  <>
    <p>{t('faq.certificates.plusCredit')}</p>
    <span className='mc-mb-5 d-block' />
  </>
)

const AnswerComponent = withI18nContext(i18nInstance)(() => {
  const value = useMCProCertsCatalogValue()
  const { isVariant3 } = useMCProExperiment()

  return (
    <div className='mc-opacity--hinted'>
      <Trans
        i18nKey={
          value
            ? 'faq.certificates.answer'
            : 'faq.certificates.answerWithoutValue'
        }
        ns={MC_PRO_TIER_I18N_NAMESPACE}
        values={{ value }}
        components={{
          p: <p />,
          separator: <span className='mc-mb-5 d-block' />,
          plusCredit: isVariant3 ? <PlusCredit /> : <></>,
          benefitsList: <BenefitsList />,
        }}
      />
    </div>
  )
})

export const FAQ_UUID = 'What Are Certificates (MC Pro)'

export const mcProCertificatesFAQ = ({
  hide = true,
}: { hide?: boolean } = {}) => [
  {
    uuid: FAQ_UUID,
    title: t(`${MC_PRO_TIER_I18N_NAMESPACE}:faq.certificates.question`),
    answer: <AnswerComponent />,
    hide,
  },
]
